import styled from "styled-components";
import { BaseButton } from "@shared/styles/common.styled";

export const HeaderWrapper = styled.div`
  background-color: #008395;
  display: flex;
  justify-content: space-between;
  padding: ${(props) => (props?.padding ? props.padding : "5px 30px")};
  border-radius: 5px 5px 0px 0px;
  margin-top: ${(props) => (props?.marginTop ? props.marginTop : "30px")};
`;

export const PopUpHeaderWrapper = styled.div`
  background: #15aee5;
  display: flex;
  justify-content: space-between;
  padding: 1.375rem;
`;

export const HeaderWrapperTable = styled.div`
  background-color: #008395;
  display: table-column-group;
  justify-content: space-between;
  padding: 15px;
  border-radius: 5px 5px 0px 0px;
`;

export const Title = styled.h3`
  color: white !important;
  text-align: left;
  width: 100%;
  font-family: "Lato";
  font-size: 20px;
  line-height: 20px;
  margin: 0;
  font-weight: normal;
`;

export const SolutionContainer = styled.div`
  margin-left: 10px;
  display: ${(props) => (props?.display ? props.display : "none")};
`;

export const GrayDarkerServiceSpan = styled.span`
  color: ${(props) => props?.color};
  position: relative;
  font-weight: ${(props) => (props?.weight ? props.weight : "400")};
  ::before {
    position: absolute;
    content: "";
    display: block;
    height: 60px;
    width: 30px;
    left: -36px;
    background: radial-gradient(circle, #0a4986 10%, transparent 10%), 8px;
    background-size: 40px 20px;
    background-repeat: no-repeat;
  }
`;

export const GrayDarkerServiceSpanWithoutBullet = styled.span`
  color: ${(props) => props?.color};
  position: relative;
  font-weight: ${(props) => (props?.weight ? props.weight : "400")};
`;

export const GrayDarkerSpan = styled.span`
  color: ${(props) => (props?.color ? props.color : "#474747")};
  font-weight: ${(props) => (props?.weight ? props.weight : "400")};
  text-align: ${(props) => (props?.textAlign ? props.textAlign : "left")};
`;

export const GraySpan = styled.span`
  color: #767676;
  text-align: ${(props) => (props?.textAlign ? props.textAlign : "left")};
  justify-self: ${(props) => (props?.textAlign ? props.textAlign : "left")};
`;

export const ActionDiv = styled.div`
  justify-items: center;
  justify-content: center;
  justify-self: center;
  display: flex;
`;

export const HeaderText = styled.span`
  color: #fff;
  text-align: ${(props) =>
    props?.textAlign ? props.textAlign : "left"} !important;
`;

export const Separator = styled.hr`
  background: #ededed;
  border: 1px solid #ededed;
  width: auto;
  margin-top: ${(props) =>
    props?.marginTop ? props.marginTop : "0px"} !important;
  margin-bottom: 15px !important;
  margin-left: -9px;
`;

export const SellingPriceLabel = styled.span`
  position: relative;
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;
  color: ${(props) => props?.color};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration: underline !important;
  cursor: pointer;
  text-transform: initial;
  margin: 0px 0 6px 0;
`;

export const ServiceSection = styled.div`
  margin-top: 0px;
  padding-bottom: 5px;
  padding-left: 10px;
  background-color: ${(props) => (props?.color ? props.color : "#fff")};
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 1.375rem;
`;

export const FormBody = styled.div`
  max-height: 60vh;
  padding: 0 1.375rem;
  overflow-y: auto;
`;
